import { createRequest } from 'utils/request';

import type { paths } from 'schemas/schema';

type QuizResults = paths['/quiz/{slug}/results/'];

const postQuizResults = createRequest<QuizResults, 'post'>('/pc/quiz/{slug}/results/', 'POST');

export default postQuizResults;
